const imageMap = new Map<string, HTMLImageElement>()

export function setImageEl(id: string, el: HTMLImageElement) {
  imageMap.set(id, el)
}

export function getImageEl(id: string): HTMLImageElement | undefined {
  return imageMap.get(id)
}

export function deleteImageEl(id:string) {
  imageMap.delete(id);
}